import Popups from '@/components/popup/enums.ts';
import Modals from '@/components/modal/enums.ts';

export function useAllModals() {
  const { openPopup } = usePopups();
  const { openModal } = useModals();
  const openError = (props: any) => {
    openPopup(Popups.error.component, { ...Popups.error.props, ...props });
  };

  const openChangeEmail = (props: any) => {
    openModal(Modals.changeEmail.component, { ...Modals.changeEmail.props, ...props });
  };

  return {
    openError,
    openChangeEmail,
  };
}
